export default {
  "active": "نشط",
  "and place orders for Table": "وتقديم الطلبات للطاولة",
  "any cell to select and edit": "أي خلية لتحديدها وتعديلها",
  "at": "في",
  "beautifully simple.": "بسيطة وجميلة.",
  "columns": "أعمدة",
  "description": "الوصف",
  "details": "التفاصيل",
  "dishes": "أطباق",
  "e.g. The amount doesn't match the order total": "مثال: المبلغ لا يطابق إجمالي الطلب",
  "e.g. This weekend only: 20% off all pizzas! 🍕": "مثال: هذا الأسبوع فقط: خصم 20% على جميع البيتزا! 🍕",
  "e.g., Bella Vista Cafe": "مثال: مقهى الواحة",
  "e.g., Main Hall, Terrace, VIP Section": "مثال: الصالة الرئيسية، التراس، قسم VIP",
  "e.g., Muscat Downtown": "مثال: مسقط وسط المدينة",
  "e.g., Small, Medium, Large": "مثال: صغير، متوسط، كبير",
  "e.g., T1, Table 1": "مثال: T1، طاولة 1",
  "each": "للواحدة",
  "earned all-time ·": "مكتسبة إجمالًا ·",
  "empty": "فارغ",
  "failed ·": "فشل ·",
  "for": "لـ",
  "for quick editing": "للتعديل السريع",
  "for “": "لـ “",
  "found": "تم العثور عليه",
  "guest": "ضيف",
  "guests": "ضيوف",
  "guests on": "ضيوف في",
  "guests · Table": "ضيوف · طاولة",
  "ingredient": "مكوّن",
  "is calculated by the store. The final total appears in your confirmation.": "يحسبه المتجر. يظهر الإجمالي النهائي في رسالة التأكيد.",
  "is not taking table reservations online right now. Please contact the restaurant directly.": "لا يستقبل حجوزات الطاولات عبر الإنترنت حاليًا. يرجى التواصل مع المطعم مباشرة.",
  "is suspended": "موقوف",
  "item": "عنصر",
  "item(s) are running low on stock": "عنصر(عناصر) على وشك النفاد",
  "items": "عناصر",
  "items ·": "عناصر ·",
  "logs": "سجلات",
  "loyalty members": "أعضاء الولاء",
  "members": "أعضاء",
  "min": "دقيقة",
  "minutes": "دقائق",
  "month": "شهر",
  "of": "من",
  "on": "في",
  "or drag and drop": "أو اسحب وأفلت",
  "our restaurant": "مطعمنا",
  "over rows/columns to see delete buttons": "فوق الصفوف/الأعمدة لإظهار أزرار الحذف",
  "people": "أشخاص",
  "per serving": "لكل حصة",
  "points": "نقاط",
  "points available": "نقاط متاحة",
  "preview": "معاينة",
  "prices in": "الأسعار بـ",
  "products": "منتجات",
  "pts": "نقطة",
  "pts to go": "نقطة متبقية",
  "pts · redeemed": "نقطة · مستبدلة",
  "result": "نتيجة",
  "rows": "صفوف",
  "rows ×": "صفوف ×",
  "rows.": "صفوف.",
  "scroll →": "مرّر ←",
  "sent ·": "مُرسلة ·",
  "services": "خدمات",
  "sold": "مُباع",
  "spent": "مُنفَق",
  "the restaurant time zone": "المنطقة الزمنية للمطعم",
  "times available": "أوقات متاحة",
  "to": "إلى",
  "to cancel": "للإلغاء",
  "to confirm.": "للتأكيد.",
  "to move to next cell": "للانتقال إلى الخلية التالية",
  "to save,": "للحفظ،",
  "total": "الإجمالي",
  "variants": "خيارات",
  "visits": "زيارات",
  "will contact you to confirm": "سيتواصل معك للتأكيد",
  "your store": "متجرك",
  "{amount} will be charged": "سيتم خصم {amount}",
  "{count} days left": "متبقٍ {count} أيام",
  "{count} products are low or out of stock.": "{count} منتجات منخفضة أو نافدة من المخزون.",
  "{created} {noun} saved · {categoriesCreated} categories created · {skipped} duplicates skipped": "تم حفظ {created} {noun} · إنشاء {categoriesCreated} تصنيفات · تخطي {skipped} مكررات",
  "{invalid} rows need a name or valid price. Check your column choices.": "{invalid} صفوف تحتاج إلى اسم أو سعر صحيح. تحقق من اختيار الأعمدة.",
  "{name} Admin": "إدارة {name}",
  "{name} added to cart": "تمت إضافة {name} إلى السلة",
  "{name} is larger than 5MB": "{name} أكبر من 5 ميغابايت",
  "{name} is not a supported image": "{name} ليست صورة مدعومة",
  "{name} is ready!": "{name} جاهز!",
  "{quantity}x {name}{variantText} added to cart": "تمت إضافة {quantity}× {name}{variantText} إلى السلة",
  "{v0} min": "{v0} دقيقة",
  "~ fresh today ~": "~ طازج اليوم ~",
  "· 90 min": "· 90 دقيقة",
  "· ask us about today's cakes ♡": "· اسألنا عن حلويات اليوم ♡",
  "العربية (Arabic)": "العربية",
  "• Backups include all database tables, settings, and configurations": "• تشمل النسخ الاحتياطية جميع جداول قاعدة البيانات والإعدادات",
  "• Keep multiple backups for different restore points": "• احتفظ بعدة نسخ احتياطية لنقاط استعادة مختلفة",
  "• Regular backups help protect against data loss": "• النسخ الاحتياطي المنتظم يحمي من فقدان البيانات",
  "• Restore operations will replace ALL current data": "• الاستعادة ستستبدل جميع البيانات الحالية",
  "• Use toolbar buttons to add rows/columns": "• استخدم أزرار شريط الأدوات لإضافة صفوف/أعمدة",
  "← Choose a different service": "→ اختر خدمة أخرى",
  "● Unsaved changes": "● تغييرات غير محفوظة",
  "✓ ORDER READY - PLEASE SERVE": "✓ الطلب جاهز - يرجى التقديم",
  "⭐ KITCHEN COPY ⭐": "⭐ نسخة المطبخ ⭐",
  "🍽️ Order Items": "🍽️ عناصر الطلب",
  "🎁 {v0} • {points_balance} pts{v2} (change)": "🎁 {v0} • {points_balance} نقطة{v2} (تغيير)",
  "💡 Click \"Print Bill\" to open print dialog in a new window": "💡 انقر على \"طباعة الفاتورة\" لفتح نافذة الطباعة",
  "💡 Tip: Ask customer to show their QR code or order code from their phone": "💡 نصيحة: اطلب من العميل عرض رمز QR أو رمز الطلب من هاتفه",
  "💰 Bill Summary": "💰 ملخص الفاتورة",
  "💵 Cash": "💵 نقدًا",
  "📝 Note:": "📝 ملاحظة:",
  "🔔 New Order Received!": "🔔 تم استلام طلب جديد!",
  "🪑 Table": "🪑 طاولة",
  "Payment recorded: {totalPaid} MAD": "تم تسجيل الدفع: {totalPaid} MAD",
  "admin": "مدير",
  "owner": "مالك",
  "manager": "مدير فرع",
  "cashier": "أمين صندوق",
  "kitchen": "مطبخ",
  "waiter": "نادل",
  "Refresh ": "تحديث "
}
